import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {RootState} from '../../store';

export interface profileState {
    id: string;
    username: string;
    name: string;
    imgURL: string
}

const initialState: profileState = {
    id: "",
    username: "",
    name: "",
    imgURL: "",
}

export const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        setId: (state, action: PayloadAction<string>) => {
            state.id = action.payload
        },
        setUsername: (state, action: PayloadAction<string>) => {
            state.username = action.payload
        },
        setName: (state, action: PayloadAction<string>) => {
            state.name = action.payload
        },
        setImgURL: (state, action: PayloadAction<string>) => {
            state.imgURL = action.payload
        }
    }
})

export const { setId, setUsername, setName, setImgURL } = profileSlice.actions

export const profile = (state: RootState) => state.profile


export default profileSlice.reducer